import angular from 'angular';
import modalQuestionCadastralComponent from './modalQuestionCadastral.component';

let modalQuestionCadastralModule = angular.module('modalQuestionCadastral', [
])

.component('modalQuestionCadastral', modalQuestionCadastralComponent)

.name;

export default modalQuestionCadastralModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/cadastralReferenceMobile/modalQuestionCadastral/modalQuestionCadastral.js